import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { SectionWrapper } from '../../SectionWrapper';
import { FormInput, IFormInputProps } from '../../merchants/FormInput';

interface Props {
  formEditStatus: boolean;
  formik: any;
  inputs: IFormInputProps[];
}
export const QuickApplicationFees: FC<Props> = (props) => {
  const { formik, formEditStatus, inputs } = props;
  const { t } = useTranslation();

  return (
    <SectionWrapper
      title={t('NEW_APPLICATION.FEES')}
      pageLoading={false}
      isCardBody
      sectionAdditionalClass="mb-10"
    >
      <div className="d-flex align-items-center flex-wrap">
        {
          inputs.map(item => {
            return (
              <FormInput
                {...item}
                formik={formik}
                isEditMode={formEditStatus}
                key={item.key}
              />
            );
          })
        }
      </div>

    </SectionWrapper>
  );
};
